import { combineReducers } from "redux";
import { all } from 'redux-saga/effects';
import auth, {authSaga} from './auth';
import loading from './loading';
import agree, {agreeSaga} from "./agree";
import survey from "./survey";
import menu from "./menu";
import address, {addrSaga} from "./address";
import user, {userSaga} from './user';
import family from "./family";
import answers from "./answers";
import file, {uploadSaga} from "./file";
import rent from "./rent";


const rootReducer = combineReducers({
    agree,
    survey,
    auth,
    menu,
    loading,
    address,
    family,
    user,
    answers,
    file,
    rent
});

export function* rootSaga() {
    yield all([authSaga(), userSaga(), addrSaga(), agreeSaga(), uploadSaga()]);
}
export default rootReducer;
